import { createRouter, createWebHistory } from "vue-router";
import LoginWithToken from "../views/LoginWithToken.vue";
import FlightPortal from "../views/FlightPortal.vue";
import FlightPortalMobile from "../views/FlightPortalMobile.vue";
// import SignUp from "../views/SignUp.vue";
// import Login from "../views/Login.vue";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../plugins/firebase.js";
import Home from "../views/Home.vue";
import Dashboard from "../views/Dashboard.vue";
import PilotDashboard from "../views/PilotDashboard.vue";
import Credits from "../views/Credits.vue";
import CreditsMobile from "../views/CreditsMobile.vue";
import How from "../views/How.vue";
import { isMobile } from "@/utils/helper";
import { useSessionStore } from "../stores/session.js";
import NewListing from "../views/NewListing.vue";
import Listings from "../views/Listings.vue";
import Listing from "../views/Listing.vue";
import Bookings from "../views/Bookings.vue";
import ListingMobile from "../views/ListingMobile.vue";
import Terms from "../views/Terms.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import Education from "../views/Education.vue";
import EducationMobile from "../views/EducationMobile.vue";
import Temples from "../views/Temples.vue";
import TemplesMobile from "../views/TemplesMobile.vue";
import Subscriptions from "../views/Subscriptions.vue";
import BecomeAPilot from "../views/BecomeAPilot.vue";
import BecomeAPilotMobile from "../views/BecomeAPilotMobile.vue";
import Blog from "../views/Blog.vue";
// import BlogTemplate from "../views/BlogTemplate.vue";
import TeamBuildingBlog from "../views/blog/TeamBuildingBlog.vue";
import EducationBlog from "../views/blog/EducationBlog.vue";
import EducationBlogCurriculum from "../views/blog/EducationBlogCurriculum.vue";
import GeographyBlog from "../views/blog/GeographyBlog.vue";
import SchoolDifferentiationBlog from "../views/blog/SchoolDifferentiationBlog.vue";
import RemoteFieldTripsBlog from "../views/blog/RemoteFieldTripsBlog.vue";
import EnrollmentBoostBlog from "../views/blog/EnrollmentBoostBlog.vue";
import SustainabilityBlog from "../views/blog/SustainabilityBlog.vue";
import ClimateChangeSeaCortesBlog from "../views/blog/ClimateChangeSeaCortesBlog.vue";
import TuitionFreeEducationBlog from "../views/blog/TuitionFreeEducationBlog.vue";
import RealTimeLearningBlog from "../views/blog/RealTimeLearningBlog.vue";
import RemoteOutdoorBlog from "../views/blog/RemoteOutdoorBlog.vue";
import StemIntegrationBlog from "../views/blog/StemIntegrationBlog.vue";
import BrandConnectionBlog from "../views/blog/BrandConnectionBlog.vue";
import BreckSchoolBlog from "../views/blog/BreckSchoolBlog.vue";
import BillableLiveExperienceBlog from "../views/blog/BillableLiveExperienceBlog.vue";
import RemoteInspectionsTrustBlog from "../views/blog/RemoteInspectionsTrustBlog.vue";
import EventAerialOverwatchBlog from "../views/blog/EventAerialOverwatchBlog.vue";
import GigsToMrrRetainersBlog from "../views/blog/GigsToMrrRetainersBlog.vue";
import SkyhostPilotPlaybookBlog from "../views/blog/SkyhostPilotPlaybookBlog.vue";
// import Landing from "../views/Landing.vue";

const isMobileDevice = isMobile();

const routes = [
  // {
  //   path: "/",
  //   name: "Landing",
  //   component: Landing,
  // },
  // {
  //   path: "/",
  //   name: "Landing",
  //   component: How,
  // },
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: Login,
  // },
  // {
  //   path: "/signup",
  //   name: "SignUp",
  //   component: SignUp,
  // },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pilot-dashboard",
    name: "PilotDashboard",
    component: PilotDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/credits",
    name: "Credits",
    component: isMobileDevice ? CreditsMobile : Credits,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    component: Subscriptions,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/how-it-works",
    name: "How",
    component: How,
  },
  {
    path: "/schools",
    name: "Schools",
    component: isMobileDevice ? EducationMobile : Education,
  },
  {
    path: "/temples",
    name: "Temples",
    component: isMobileDevice ? TemplesMobile : Temples,
  },
  {
    path: "/blogs",
    name: "Blog",
    component: Blog,
  },
  // Replacing the dynamic route with individual blog routes
  {
    path: "/blog/team-building-tips",
    name: "TeamBuildingBlog",
    component: TeamBuildingBlog,
  },
  {
    path: "/blog/education-drones",
    name: "EducationBlog",
    component: EducationBlog,
  },
  {
    path: "/blog/education-curriculum",
    name: "EducationCurriculumBlog",
    component: EducationBlogCurriculum,
  },
  {
    path: "/blog/geography-drone-lessons",
    name: "GeographyBlog",
    component: GeographyBlog,
  },
  {
    path: "/blog/school-differentiation",
    name: "SchoolDifferentiationBlog",
    component: SchoolDifferentiationBlog,
  },
  {
    path: "/blog/remote-field-trips",
    name: "RemoteFieldTripsBlog",
    component: RemoteFieldTripsBlog,
  },
  {
    path: "/blog/enrollment-boost",
    name: "EnrollmentBoostBlog",
    component: EnrollmentBoostBlog,
  },
  {
    path: "/blog/sustainability-drone-education",
    name: "SustainabilityBlog",
    component: SustainabilityBlog,
  },
  {
    path: "/blog/climate-change-sea-cortes",
    name: "ClimateChangeSeaCortesBlog",
    component: ClimateChangeSeaCortesBlog,
  },
  {
    path: "/blog/tuition-free-education",
    name: "TuitionFreeEducationBlog",
    component: TuitionFreeEducationBlog,
  },
  {
    path: "/blog/real-time-learning",
    name: "RealTimeLearningBlog",
    component: RealTimeLearningBlog,
  },
  {
    path: "/blog/remote-outdoor-classes",
    name: "RemoteOutdoorBlog",
    component: RemoteOutdoorBlog,
  },
  {
    path: "/blog/stem-integration",
    name: "StemIntegrationBlog",
    component: StemIntegrationBlog,
  },
  {
    path: "/blog/brand-connection",
    name: "BrandConnectionBlog",
    component: BrandConnectionBlog,
  },
  {
    path: "/blog/breck-school-tour",
    name: "BreckSchoolBlog",
    component: BreckSchoolBlog,
  },
  {
    path: "/blog/billable-live-experience",
    name: "BillableLiveExperienceBlog",
    component: BillableLiveExperienceBlog,
  },
  {
    path: "/blog/remote-inspections-trust",
    name: "RemoteInspectionsTrustBlog",
    component: RemoteInspectionsTrustBlog,
  },
  {
    path: "/blog/event-aerial-overwatch",
    name: "EventAerialOverwatchBlog",
    component: EventAerialOverwatchBlog,
  },
  {
    path: "/blog/gigs-to-mrr-retainers",
    name: "GigsToMrrRetainersBlog",
    component: GigsToMrrRetainersBlog,
  },
  {
    path: "/blog/pilot-playbook",
    name: "SkyhostPilotPlaybookBlog",
    component: SkyhostPilotPlaybookBlog,
  },
  {
    path: "/become-a-pilot",
    name: "Become a Pilot",
    component: isMobileDevice ? BecomeAPilotMobile : BecomeAPilot,
  },
  {
    path: "/new-flight",
    name: "NewFlight",
    component: LoginWithToken,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/list-an-event",
    name: "NewListing",
    component: NewListing,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/listings",
    name: "Listings",
    component: Listings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bookings",
    name: "Bookings",
    component: Bookings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/listing",
    name: "Listing",
    component: isMobileDevice ? ListingMobile : Listing,
  },
  {
    path: "/:roomCode",
    name: "FlightPortal",
    component: isMobileDevice ? FlightPortalMobile : FlightPortal,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: PrivacyPolicy,
  },
];

const router = createRouter({
  history: createWebHistory(),
  mode: "hash",
  routes,
  scrollBehavior() {
    // Always scroll to top when navigating to a new route
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const sessionStore = useSessionStore();

  // Check the authentication state regardless of whether the route requires auth
  onAuthStateChanged(auth, (user) => {
    if (user) {
      console.log("User is authenticated:", user.uid);
      sessionStore.setUserId(user.uid);
    } else {
      console.log("User is not authenticated");
      sessionStore.setUserId(null);
    }

    // Check if the route requires authentication
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (user) {
        next(); // Proceed if the user is authenticated
      } else {
        next({ path: "/" }); // Redirect to home if not authenticated
      }
    } else {
      next(); // Allow navigation for public routes
    }
  });
});

// router.beforeEach((to, from, next) => {
//   const sessionStore = useSessionStore();
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     // If the route requires authentication, we use onAuthStateChanged to check auth state
//     onAuthStateChanged(auth, (user) => {
//       if (user) {
//         console.log("User is authenticated:");
//         sessionStore.setUserId(user.uid);
//         next(); // User is authenticated, proceed to the route
//       } else {
//         console.log("User is not authenticated");
//         sessionStore.setUserId(null);
//         next({ path: "/" }); // Not authenticated, redirect to login
//       }
//     });
//   } else {
//     next(); // Route does not require authentication
//   }
// });

export default router;
